export enum AuthenticationProvider {
  Workday = 'workday',
  Evisort = 'evisort',
}
